<template>
    <div>
        <h2>Employer(s)</h2>

        <b-row v-for="employer in value" :key="employer.id">
            <b-col cols="12"><BaseTextOutput label="Employer/Establishment Name" :value="employer.name"/></b-col>
            <b-col cols="4"><BaseTextOutput label="Street Address" :value="employer.streetAddress"/></b-col>
            <b-col cols="3"><BaseTextOutput label="City" :value="employer.city"/></b-col>
            <b-col cols="2"><BaseTextOutput label="State" :value="employer.state"/></b-col>
            <b-col cols="3"><BaseTextOutput label="Postal Code" :value="employer.postalCode"/></b-col>
            <b-col cols="4"><BaseTextOutput label="Phone" :value="employer.phone"/></b-col>
            <b-col cols="3"><BaseTextOutput label="Email Address" :value="employer.emailAddress"/></b-col>
            <b-col cols="3"><BaseTextOutput label="Dates" :value="employer.startDate"/></b-col>
        </b-row>
    </div>
</template>

<script>  
export default {
    props: {
        value: Array,
    },
}
</script>

<style>
</style>
